export default __webpack_public_path__ + "static/media/btn-hover-mulai-game.8c073af1.png";